import {translation} from "@2d-front-monorepo/core";
import React, {JSX, memo} from "react";
import {paymentStatusLabel, paymentStatusName} from "../helpers/enumNaming";
import IPayment from "../interfaces/IPayment";

function PaymentStatusComponent({payment}: { payment: IPayment | undefined }): JSX.Element {
	if (payment == null) {
		return <></>;
	}

	const paymentStatus = payment.status;
	const pillClass = `pill pill__payment-status--${paymentStatusName(paymentStatus)}`;
	return (<div className={pillClass}>{translation(paymentStatusLabel(paymentStatus))}</div>);
}

const MemoizedPaymentStatusComponent: React.FC<{
	payment: IPayment | undefined
}> = memo(PaymentStatusComponent);
export default MemoizedPaymentStatusComponent;
